import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to top whenever the route changes.
 * Anchor links (#hash) are preserved with retry logic to handle
 * pages that load data asynchronously (sections may appear after a delay).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      // Try multiple times with increasing delays in case the section
      // is rendered after async data load.
      const attempts = [50, 200, 500, 1000, 1500, 2500];
      let cancelled = false;
      attempts.forEach((delay) => {
        setTimeout(() => {
          if (cancelled) return;
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            cancelled = true; // stop further retries once found
          }
        }, delay);
      });
      return () => { cancelled = true; };
    }
    // No hash → scroll to top
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
